import { useState } from "react";

import { Tabs, type TabItem } from "@/components/common";
import { useIncidents, useRetentionPolicies, useSubjectRequests } from "@/hooks/useLgpd";
import { IncidentsPanel } from "./IncidentsPanel";
import { PiiAccessLogsPanel } from "./PiiAccessLogsPanel";
import { RetentionPanel } from "./RetentionPanel";
import { SubjectRequestsPanel } from "./SubjectRequestsPanel";
import "./LgpdPanel.css";

type Sub = "requests" | "incidents" | "retention" | "pii-access";

export function LgpdPanel() {
  const [sub, setSub] = useState<Sub>("requests");
  const { data: requests = [] } = useSubjectRequests();
  const { data: incidents = [] } = useIncidents();
  const { data: policies = [] } = useRetentionPolicies();

  const pendingRequests = requests.filter(
    (r) => r.status === "received" || r.status === "under_review",
  ).length;

  const tabs: TabItem<Sub>[] = [
    { id: "requests", label: "Solicitações", count: pendingRequests || requests.length },
    { id: "incidents", label: "Incidentes", count: incidents.length },
    { id: "retention", label: "Retenção", count: policies.length },
    { id: "pii-access", label: "Acessos a PII" },
  ];

  return (
    <div className="lgpd-panel">
      <Tabs items={tabs} active={sub} onChange={setSub} />
      {sub === "requests" && <SubjectRequestsPanel />}
      {sub === "incidents" && <IncidentsPanel />}
      {sub === "retention" && <RetentionPanel />}
      {sub === "pii-access" && <PiiAccessLogsPanel />}
    </div>
  );
}
